import { Country, usaName } from '../constants/countries';
import { VALIDATION_REGEX } from '../validators/validationRegex';

export const healZipPostalCodeValue = (
  zipPostalCode: string,
  country: Country | null,
) => {
  if (!zipPostalCode) {
    return zipPostalCode;
  }

  if (!country || country === usaName) {
    // Normalize value by replacing hyphen with space (12345-6789 -> 12345 6789)
    const normalizedValue = zipPostalCode.trim().replace(/-/g, ' ');

    if (VALIDATION_REGEX.usaZipCode.test(normalizedValue)) {
      return normalizedValue;
    }

    const digitsOnlyValue = normalizedValue.replace(/\D/g, '');

    // Handle case where value is
    if (digitsOnlyValue.length === 5) {
      return digitsOnlyValue;
    }

    // Handle case where 67401.0 -> 67401
    if (digitsOnlyValue.length > 5) {
      const firstFiveDigits = digitsOnlyValue.slice(0, 5);
      const remainingDigits = digitsOnlyValue.slice(5);

      if (/^0+$/.test(remainingDigits)) {
        return firstFiveDigits;
      }
    }
  } else if (country === 'Canada') {
    return zipPostalCode.trim().toUpperCase();
  }

  return zipPostalCode;
};
